// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-m_ij"};